import type { PostalAddress } from './postal-address.type.ts';
export interface PostalAddressExtension extends PostalAddress {}
export class PostalAddressExtension {
  //* Computed Properties */
  get isPayment() {
    return this.postalAddressType === 'PAYMENT';
  }
}

const Registration = {
  kind: 'object',
  name: 'postal-address',
  features: PostalAddressExtension,
};
export default Registration;
